export default {
  Email: 'E-Mail',
  ConfirmEmail: 'Bestätigen Sie E-Mail',
  Password: 'Kennwort',
  Verificationcode: 'Verifizierungs-Code',
  AlreadyhaveaHitPawaccountLogin:
    'Haben Sie bereits ein HitPaw-Konto? Anmeldung',
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
    'Mit der Anmeldung erklären Sie sich mit unseren Nutzungsbedingungen und Datenschutzrichtlinien einverstanden.',
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
    'Wenn Sie fortfahren, erklären Sie sich mit unseren Nutzungsbedingungen und Datenschutzerklärung einverstanden.',
  Byproceedingyouagreetoour:
    'Wenn Sie fortfahren, erklären Sie sich mit unseren ',
  ServicesofUse: 'Nutzungsbedingungen',
  and: ' und ',
  PrivacyPolicy: 'Datenschutzerklärung',
  last: ' einverstanden.',
  TheEmailformatisincorrect: 'Das E-Mail-Format ist falsch',
  Pleaseenterthesameemailinbothfields:
    'Bitte geben Sie in beide Felder die gleiche E-Mail ein.',
  Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
    'Das Passwort muss 8-50 Zeichen lang sein und Zahlen, Groß- und Kleinbuchstaben enthalten.',
  Incorrectverificationcode: 'Falscher Bestätigungscode',
  ThisEmailhasbeenregisteredpleasechooseanother:
    'Die E-Mail wurde registriert, bitte wählen Sie eine andere E-Mail.',
  Cannotbeemptyhere: 'Kann hier nicht leer sein.',
  Rememberme: 'Erinnern Sie sich an mich',
  ForgotPassword1: 'Passwort vergessen?',
  NotaregistereduseryetSignUp: 'Noch kein registrierter Benutzer? Aufsingen',
  Notaregistereduseryet1: 'Noch kein registrierter Benutzer? ',
  Notaregistereduseryet2: 'Aufsingen',
  NoaccountfoundwiththatEmailaddress:
    'Kein Konto mit dieser E-Mail Adresse gefunden',
  YourEmailaddressorpasswordwasincorrectPleasetryagain:
    'Ihre E-Mail oder Ihr Passwort war falsch. Bitte versuchen Sie es erneut.',
  ForgotPassword2: 'Passwort vergessen',
  GetVerificationCode: 'Code erhalten',
  VerifyEmail: 'E-Mail bestätigen',
  Ithasbeensenttoyourmailboxpleasecheckit:
    'Es wurde an Ihre Mailbox gesendet, bitte überprüfen Sie es',
  PleaseinputEmailaddress: 'Bitte E-Mail Adresse eingeben',
  TheEmailisnotregistered: 'Die Mailbox ist nicht registriert',
  Invalidverificationcodepleasereenterthecorrectone:
    'Fehler beim Verifizierungscode, bitte versuchen Sie es erneut',
  Resetpassword: 'Passwort zurücksetzen',
  Emailaddressverificationsucceeded: 'Mailbox-Überprüfung erfolgreich',
  Pleaseresetyourpassword: 'Bitte setzen Sie Ihr Passwort zurück',
  Enteranewpassword: 'Geben Sie ein neues Passwort ein',
  Confirm: 'Bestätigen Sie',
  Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
    'Neue Passwörter sollten 8-50 Zeichen lang sein und aus Buchstaben oder Zahlen oder einer Mischung aus Buchstaben und Zahlen bestehen.',
  Passwordresetsuccessfully: 'Passwort erfolgreich geändert',
  Name: 'Name',
  GetCode: 'Code erhalten',
  Loginsuccessful: 'Login erfolgreich',
  Loginfailed: 'Login fehlgeschlagen',
  Signupsuccessful: 'Anmeldung erfolgreich',
  Signupfailed: 'Anmeldung fehlgeschlagen',
  Getpassword: 'Passwort erhalten',
  Authorizationhasexpiredpleaseloginagain:
    'Die Berechtigung ist abgelaufen, bitte melden Sie sich erneut an.',
  Sorrysomethingwentwrongpleasetryagainlater:
    'Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
  Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
    'Es wurden zu viele gleiche Anfragen in einem kurzen Zeitraum gestellt, bitte versuchen Sie es später noch einmal.',
  Couldntfindyouraccountorthepasswordisincorrect:
    'Ihr Konto konnte nicht gefunden werden, oder das Passwort ist falsch.',
  Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
    'Sie versuchen, auf eine kostenpflichtige Funktion zuzugreifen, bitte melden Sie sich zuerst an.',
  Accessdeniedfortheunauthorizedrequest:
    'Zugriff verweigert für die nicht autorisierte Anfrage.',
  Alreadyhaveaccount: 'Haben Sie schon Konto?',
  SignUpwithemail: 'Mit E-Mail anmelden',
  Securityverification: 'Sicherheitsüberprüfung',
  Pleaseenterthecorrectemailaddress:
    'Bitte geben Sie die korrekte E-Mail-Adresse ein!',
  PleaseInputverificationCode: 'Bitte geben Sie den Bestätigungscode ein!',
  Pleaseenterthesamepasswordinbothfields:
    'Bitte geben Sie in beide Felder das gleiche Passwort ein!',
  or: 'oder',
  ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
    'Das neue Passwort, das Sie eingegeben haben, ist dasselbe wie Ihr altes Passwort. Geben Sie ein anderes Passwort ein',
  YourpasswordwasincorrectPleasetryagain:
    'Ihr Passwort war falsch. Bitte versuchen Sie es erneut.',
  reg400:
    'Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
  reg400223:
    'E-Mail und Verifizierungscode stimmen nicht überein, bitte überprüfen Sie es.',
  reg400224: 'Token ist abgelaufen',
  500: 'Serverseitiger Fehler!',
  Afewsecondsaway: 'Anmelden oder registrieren Sie sich in wenigen Sekunden',
  ContinuewithGoogle: 'Weiter mit Google',
  ContinuewithEmail: 'Weiter mit E-Mail',
  LoginwithEmail: 'Weiter mit E-Mail',
  Usemorethan8charactersandmixlettersnumbersandsymbols:
    'Verwenden Sie mehr als 8 Zeichen mit einer Mischung aus Buchstaben, Zahlen und Symbolen (unterstützende Symbole: @$!%*#_~?&^)',
  ConfirmPassword: 'Bestätigen Sie Ihr Passwort',
  Pleaseloginwithemail: 'Bitte melden Sie sich mit Email an',
  youraccount: 'Ihr Konto',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    'existiert bereits, um die Sicherheit Ihres Kontos zu gewährleisten, führen Sie bitte zuerst die Verifizierung durch.',
  //temp中暂定补充
  Checkyourconnectionandtryagain:
    'Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  continue: 'weiter',
  Deleteallmarkedclips: 'Alle markierten Clips löschen',
  Automaticallydetectsilencesandmarkthemfromyourvideo:
    'Erkennen Sie automatisch Geräusche und markieren Sie sie aus Ihrem Video',
  Login: 'Anmelden',
  exceed6Times:
    'Ihre Testversion ist heute abgelaufen, bitte führen Sie ein Upgrade auf Pro durch, um auf alle Premium- Funktionen zugreifen zu können.',
  exceed20M:
    'Die Dateigröße für kostenlose Konten darf 20 MB nicht überschreiten.Bitte führen Sie ein Upgrade auf Pro durch, um auf alle Premium- Funktionen zugreifen zu können.',
  403102: 'Das Google-Konto wurde an ein anderes Konto gebunden',
};
